module.exports = __webpack_public_path__ + "static/media/moonmen.ad95f6b7.wav";